import { render, staticRenderFns } from "./standardTask.vue?vue&type=template&id=8c850996&scoped=true&"
import script from "./standardTask.vue?vue&type=script&lang=js&"
export * from "./standardTask.vue?vue&type=script&lang=js&"
import style0 from "./standardTask.vue?vue&type=style&index=0&id=8c850996&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c850996",
  null
  
)

export default component.exports